export default __webpack_public_path__ + "static/media/group2.71c61307.webp";